<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert type="warning" show-icon>
            招聘会须知
            <template slot="desc">
              1、进入远程面试室，请确认电脑配备了摄像头和麦克风，进入市场前会进行环境检测，未满足设备和网络要求将无法进入功能操作。
              <br>
              2、该测试仅为硬件测试，进入市场前请确认已打开了声音和麦克风，并调至合适音量。
              <br>
              3、暂不支持国外线路，请确认您所用网络环境为国内线路。
              <br>
              4、线上远程企业在招聘会当天上线直接“进入”招聘会即可，无需提前申请。
              <br>
              5、具有实体摊位的市场可根据实际情况进行摊位申请，并在当天准时到达现场。
            </template>
          </Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="可输入日期、市场等相关信息直接搜索" @on-enter="searchinput"/>
<!--            <DatePicker  type="date" editable v-model="searchdate" format="yyyy-MM-dd" placement="bottom-end" placeholder="请选择市场日期" ></DatePicker>-->
            <slot name="new_btn">
<!--              <Button type="primary" @click="videotest" class="search-btn">远程面试实景检测室</Button>-->
            </slot>



          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="500" size="small" ref="selection" border :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>

          <Modal v-model="modalApply.modalVisible" :title="modalApply.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formapplydate" :model="formapplydate" :label-width="100">
              <el-image :src="img_show" style="margin: 10px;"></el-image>
              <FormItem
                label="摊位号"
                prop="ajnum"
              >
                <el-radio-group v-model="formapplydate.ajnum" v-for="item in formapplydate.Jnum_list">
                  <el-radio-button  :label="formatZero(item.num,2)" :value="item.num"
                                   v-if="item.cid==0"></el-radio-button>
                  <el-radio-button :label="formatZero(item.num,2)" :value="item.num"
                                   v-else disabled></el-radio-button>
                </el-radio-group>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit_apply()"
                >申请
                </Button>

              </FormItem>
            </Form>
          </Modal>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <template>
                <Steps :current="checknum" direction="vertical" :status="checkstatus">
                  <Step :title="checkstep1" content="远程面试服务连接"></Step>
                  <Step :title="checkstep2" content="视频图像解析"></Step>
                  <Step :title="checkstep3" content="摄像头"></Step>
                  <Step :title="checkstep4" content="麦克风"></Step>
                  <Step :title="checkstep5" content="视频编码"></Step>
                </Steps>
              </template>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>

  </div>
</template>

<script>


  import {
    getJobfairlist,
    operationJobfair,
    changecompanyonline,
    changeJobfair,
    jobfairapplypost
  } from '@/api/apply/apply.js'
  import {ZegoExpressEngine} from 'zego-express-engine-webrtc'
  import {getsysparameterList} from "@/api/system/sys_parameter";
  import img from '@/assets/images/booth_kfqNew.png';
  import {getMarketlist} from '@/api/scinfo/scinfo'

  // import {Notification} from 'element-ui';

  let moment = require("moment");
  export default {

    data() {
      return {
        img_show:'',
        checknum:0,
        checkstatus:'wait',
        checkstep1:'检测中...',
        checkstep2:'待检测',
        checkstep3:'待检测',
        checkstep4:'待检测',
        checkstep5:'待检测',
        isok:0,
        spinShow:false,
        fullscreenLoading:false,
        JtypeList:[],
        MarketList:[],
        formValidate: {
          Id:0,
          Mid:0,
          Jname: "",
          Jstime: "",
          Jtype: 0,
          Jotime: "",
          Jstate: 0,
          Jnum:0
        },
        formapplydate:{
          id:0,
          acid:0,
          ajid:0,
          ajnum:0,
          jnum:0,
          Jnum_list:[]
        },
        searchVal: "",
        tableData: [],
        modalMap: {
          modalVisible: false,
          modalTitle: "环境检测"
        },
        modalApply: {
          modalVisible: false,
          modalTitle: "申请摊位"
        },
        tableSelectIdList:[],
        editModalData: "",
        pageNum: 1, // 当前页码
        pageTotal: 0, // 数据总数j
        pageSize: 15, // 每页条数


        ruleValidate: {
          // admin_user: [{ required: true, message: "请选择管理用户", trigger: "change"}],
          Jname: [
            {
              required: true,
              message: "招聘会主题不能为空",
              trigger: "blur"
            }
          ],
          Jstime: [
            {
              required: true,
              type:'date',
              message: "开始时间不能为空",
              trigger: "blur"
            }
          ],
          Jotime: [
            {
              required: true,
              type:'date',
              message: "结束时间不能为空",
              trigger: "blur"
            }
          ],
          Jtype: [
            {
              required: true,
              message: "请选择类型",
              trigger: "change"
            }
          ],
          Mid: [
            {
              required: true,
              message: "请选择市场",
              trigger: "change"
            }
          ]

        },
        columns: [
          {
            type: 'selection',
            key: 'id',
            width: 60,
            align: 'center'
          },
          {
            title: "招聘会主题",
            key: "Jname",
            align: "center",
            sortable: true
          },
          {
            title: "开始时间",
            key: "Jstime",
            align: "center",
            sortable: true
          },
          {
            title: "结束时间",
            key: "Jotime",
            align: "center",
            sortable: true
          },
          {
            title: "招聘市场",
            key: "M_Mname",
            align: "center",
            sortable: true
          },
          {
            title: "摊位情况",
            key: "Jnum_ST",
            align: "center",
            sortable: true
          },
          {
            title: "类型",
            key: "Jtype_CN",
            align: "center",
            sortable: true
          },
          {
            title: "状态",
            key: "Jstate_CN",
            align: "center",
            sortable: true,
            width:100
          },

          {
            title: "操作",
            key: "handle",
            width:150,
            align: "center",
            render: (h, params) => {
              var day2 = new Date();
              var Jstime = new Date(params.row.Jstime);
              var Jotime = new Date(params.row.Jotime);
              var Jnum = params.row.Jnum;
              if(Jotime >= day2 && Jstime <= day2) {
                if(this.isok==0){
                  if (params.row.Jnum_list) {
                    return h("div", [
                      h(
                        "Button",
                        {
                          props: {
                            type: "primary",
                            size: "small"
                          },
                          style: {
                            marginRight: "5px"
                          },
                          on: {
                            click: () => {
                              this.checkAnRun();
                            }
                          }
                        },
                        "检测"
                      ),
                      h(
                        "Button",
                        {
                          props: {
                            type: "success",
                            size: "small"
                          },
                          style: {
                            marginRight: "5px"
                          },
                          on: {
                            click: () => {
                              this.jobfairapply(params.row);
                            }
                          }
                        },
                        "申请"
                      )
                    ]);
                  }else{
                    return h("div", [
                      h(
                        "Button",
                        {
                          props: {
                            type: "primary",
                            size: "small"
                          },
                          style: {
                            marginRight: "5px"
                          },
                          on: {
                            click: () => {
                              this.checkAnRun();
                            }
                          }
                        },
                        "检测"
                      )
                    ]);
                  }
                }else {
                  if (params.row.Jnum_list) {
                    return h("div", [
                      h(
                        "Button",
                        {
                          props: {
                            type: "primary",
                            size: "small"
                          },
                          style: {
                            marginRight: "5px"
                          },
                          on: {
                            click: () => {
                              this.jobfairin(params.row);
                            }
                          }
                        },
                        "进入"
                      ),
                      h(
                        "Button",
                        {
                          props: {
                            type: "success",
                            size: "small"
                          },
                          style: {
                            marginRight: "5px"
                          },
                          on: {
                            click: () => {
                              this.jobfairapply(params.row);
                            }
                          }
                        },
                        "申请"
                      )
                    ]);
                  }else{
                    return h("div", [
                      h(
                        "Button",
                        {
                          props: {
                            type: "primary",
                            size: "small"
                          },
                          style: {
                            marginRight: "5px"
                          },
                          on: {
                            click: () => {
                              this.jobfairin(params.row);
                            }
                          }
                        },
                        "进入"
                      )
                    ]);
                  }
                }
              }else if(Jstime >= day2){
                if (params.row.Jnum_list) {
                  return h("div", [
                    h(
                      "Button",
                      {
                        props: {
                          type: "success",
                          size: "small"
                        },
                        style: {
                          marginRight: "5px"
                        },
                        on: {
                          click: () => {
                            this.jobfairapply(params.row);
                          }
                        }
                      },
                      "申请"
                    )
                  ]);
                }else{
                  return h("div", [
                    h(
                      "Button",
                      {
                        props: {
                          type: "info",
                          size: "small"
                        },
                        style: {
                          marginRight: "5px"
                        },
                        on: {
                          click: () => {

                          }
                        }
                      },
                      "已申请"
                    )
                  ]);
                }
              }else{
                return h("div", [
                  h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small"
                      },
                      style: {
                        marginRight: "5px"
                      },
                      on: {
                        click: () => {
                          this.$router.push({
                            name: 'apply_application'
                          })
                        }
                      }
                    },
                    "应聘信息"
                  )
                ]);
              }

            }
          }
        ],
      };
    },
    methods: {

      handleSubmit_apply() {
        jobfairapplypost(this.formapplydate, 'post').then(res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  if (this.searchVal) {
                    this.getJobfairlist(this.searchVal)
                  }else{

                    this.getJobfairlist()

                  }
                  this.modalApply.modalVisible = false;

                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })

      },
      videotest(){

      },

      // 获取TagTree

      getJobfairlist(key, value) {
        this.spinShow = true
        getJobfairlist(this.pageNum, this.pageSize, key, value).then(res => {
          if (res.data.code === 0) {
            this.pageTotal = res.data.count
            this.tableData = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
          this.spinShow = false
        })
      },


      // table 选中的ID
      handleSelectChange(val) {
        let SelectIdList = []
        val.forEach(item => {
          SelectIdList.push(item.Id)
        })

        this.tableSelectIdList = SelectIdList
      },


      closeModal() {
        this.dialog.show = false

      },
      getJtypeList() {
        getsysparameterList('jobfair_info', 'Jtype').then(res => {
          if (res.data.code === 0) {
            this.JtypeList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },
      getMarketList() {
        getMarketlist().then(res => {
          if (res.data.code === 0) {
            this.MarketList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },
      jobfairin(value) {
        changecompanyonline(value, 'POST').then(res => {
          if (res.data.code === 0) {
            this.$router.push({
              name: 'apply_online',
              query: {
                jobfair_id: value.Id
              }
            })
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })



      },

      async checkAnRun() {
        this.modalMap.modalVisible = true;
        let appID = 4225061468
        //let aoosign = '22f0dccdfaa47fb628f09d29d0cd18736ab9df0c2591ecf19d94359437835a0d'
        let server = "wss://webliveroom-test.zego.im/ws"
        const zg = new ZegoExpressEngine(appID, server)
        console.log('sdk version is', zg.getVersion());
        const result = await zg.checkSystemRequirements();
        console.log(result)
        this.checknum = 0
        if (!result.webRTC){
          this.checkstatus="error"
          this.checkstep1="异常、不通过1"
        }else{
          this.checknum = 1
          this.checkstep1="通过"
          if (!result.customCapture) {
            this.checkstatus = "error"
            this.checkstep2 = "异常、不通过"
          }else{
            this.checknum = 2
            this.checkstep2="通过"
            if (!result.camera) {
              this.checkstatus = "error"
              this.checkstep3 = "异常、不通过"
            }else{
              this.checknum = 3
              this.checkstep3="通过"
              if (!result.microphone) {
                this.checkstatus = "error"
                this.checkstep4 = "异常、不通过"
              }else{
                this.checknum = 4
                this.checkstep4="通过"
                if (!result.videoCodec.H264) {
                  this.checkstatus = "error"
                  this.checkstep5 = "异常、不通过"
                }else{
                  this.checknum = 5
                  this.checkstep5="通过"
                  this.isok = 1
                }
              }
            }
          }
        }
        //
        // console.warn('checkSystemRequirements ', result);
        // videoCodec = result.videoCodec.VP8 ? 'VP8' : result.videoCodec.H264 ? 'H264' : undefined;
        // $('#videoCodeType option:eq(0)').val(videoCodec ? videoCodec : '');
        // !result.videoCodec.H264 && $('#videoCodeType option:eq(1)').attr('disabled', 'disabled');
        // !result.videoCodec.VP8 && $('#videoCodeType option:eq(2)').attr('disabled', 'disabled');
        //
        // if (!result.webRTC) {
        //   alert('browser is not support webrtc!!');
        //   return false;
        // } else if (!result.videoCodec.H264 && !result.videoCodec.VP8) {
        //   alert('browser is not support H264 and VP8');
        //   return false;
        // } else {
        //   previewVideo = $('#previewVideo')[0] as HTMLVideoElement;
        //   start();
        // }
        //
        // return true;
      },

      handleSearch() {
        this.getJobfairlist(this.searchVal);
      },
      jobfairapply(paramsRow){
        this.modalApply.modalVisible = true;
        this.formapplydate.ajnum = 0;
        this.formapplydate.Jnum_list = paramsRow.Jnum_list;
        this.formapplydate.ajid = paramsRow.Id;
        if (paramsRow.M_img){
          this.img_show = '/upload-image/' + paramsRow.M_img;
        }else{
          this.img_show = '';
        }

      },
      changePage(value) {
        this.pageNum = value
        if (this.searchVal) {
          this.getJobfairlist(this.searchVal)
        }else{

          this.getJobfairlist()

        }
      },
      // 切换分页
      handlePageSize(value) {
        this.pageSize = value
        this.pageNum = 1
        if (this.searchVal) {
          this.getJobfairlist(this.searchVal)
        }else{
          this.getJobfairlist()
        }
      },
      formatZero(num, len) {
        if(String(num).length > len) return num;
        return (Array(len).join(0) + num).slice(-len);
      },
      searchinput(){
        if (this.searchVal) {
          this.getJobfairlist(this.searchVal)
        }else{
          this.getJobfairlist()
        }
      }
    },

    watch: {
      searchVal(val) {
        this.searchVal = val
        // this.getServerList(this.searchVal)
      }
    },
    mounted() {
      this.getJobfairlist();
      this.checkAnRun();
    }
  }

</script>

<style lang="less" scoped>
  .search-con {
    padding: 10px 0;

    .search {
      &-col {
        display: inline-block;
        width: 200px;
      }

      &-input {
        display: inline-block;
        width: 200px;
        margin-left: 2px;
      }

      &-btn {
        margin-left: 2px;
      }
    }
  }
</style>
